OC__Related_Properties = {
	init : function()
	{
		// Check for related properties wrappers.
		if( jQuery('[data-type="oc-related-properties"]').length )
		{
			OC__Related_Properties.load_data();
		}
	}
	,
	load_data: function( pm_options )
	{
		// Track response
		var response = {};
		response.success = false;
		response.error = '';
		response.config = {};
		response.config.data = {};
		
		// Check for our on-page parameter object.
		if(typeof oc__oncloud_settings === 'undefined')
		{
			response.error = 'Parameter object not found';
			return(response);
		}
		
		// Get the Property ID parameter.
		var property_id = jQuery('[data-type="oc-related-properties"]').attr('data-property-id');
		var list_view = jQuery('[data-type="oc-related-properties"]').attr('data-list-view');
		
		// Assemble the endpoint.
		var data_url = oc__oncloud_settings.url + 'library/property/services/get-related-properties-html.php';
		
		var data_options = {};
		data_options.property_id = property_id; //'311564643817227723000RK';
		data_options.list_view = list_view; //'tile';
		
		jQuery.ajax({
			url: data_url,
			type: 'POST',
			data: JSON.stringify(data_options),
			contentType: 'text/plain; charset=utf-8',
			dataType: 'json',
			success: function(result){
						
				if( result.success )
				{
					// Load HTML.
					jQuery('[data-type="oc-related-properties"]').html(result.html);
						
					// Initialise UI.
					///OC__Property_reviews.init_ui();
				}
				else
				{
					response.error = result.error;
				}
			}
			,
			error: function(request, status, error){
				//console.log('ERROR:', 'REQUEST:', request, 'STATUS:', status,'ERROR:', error);
				//if(status == 'error')
				//{
					//response.error = 'XHR error';
				//}
			}
		});	
	}
}

jQuery(document).ready(function(jQuery){
	
	OC__Related_Properties.init();
	
});